class CoinbaseWebSocket {
  constructor() {
    this.ws = null;
    this.subscriptions = new Set();
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 5;
    this.reconnectDelay = 1000;
    this.isConnected = false;
    this.onMessageCallback = null;
  }

  connect() {
    try {
      this.ws = new WebSocket('wss://ws-feed.exchange.coinbase.com');

      this.ws.onopen = () => {
        console.log('Coinbase WebSocket connected');
        this.isConnected = true;
        this.reconnectAttempts = 0;

        // Subscribe to all previously subscribed symbols
        this.subscriptions.forEach((symbol) => {
          this.subscribe(symbol);
        });
      };

      this.ws.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (this.onMessageCallback) {
          this.onMessageCallback(data);
        }
      };

      this.ws.onclose = () => {
        console.log('Coinbase WebSocket disconnected');
        this.isConnected = false;
        this.handleReconnect();
      };

      this.ws.onerror = (error) => {
        console.error('Coinbase WebSocket error:', error);
        this.isConnected = false;
      };
    } catch (error) {
      console.error('Failed to create WebSocket connection:', error);
      this.handleReconnect();
    }
  }

  handleReconnect() {
    if (this.reconnectAttempts < this.maxReconnectAttempts) {
      this.reconnectAttempts += 1;
      console.log(`Attempting to reconnect... (${this.reconnectAttempts}/${this.maxReconnectAttempts})`);

      setTimeout(() => {
        this.connect();
      }, this.reconnectDelay * this.reconnectAttempts);
    } else {
      console.error('Max reconnection attempts reached');
    }
  }

  subscribe(symbol) {
    if (!this.isConnected) {
      this.subscriptions.add(symbol);
      return;
    }

    const subscribeMessage = {
      type: 'subscribe',
      product_ids: [`${symbol.toUpperCase()}-USD`],
      channels: ['ticker'],
    };

    this.ws.send(JSON.stringify(subscribeMessage));
    this.subscriptions.add(symbol);
  }

  unsubscribe(symbol) {
    if (!this.isConnected) {
      this.subscriptions.delete(symbol);
      return;
    }

    const unsubscribeMessage = {
      type: 'unsubscribe',
      product_ids: [`${symbol.toUpperCase()}-USD`],
      channels: ['ticker'],
    };

    this.ws.send(JSON.stringify(unsubscribeMessage));
    this.subscriptions.delete(symbol);
  }

  setMessageCallback(callback) {
    this.onMessageCallback = callback;
  }

  disconnect() {
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
    this.isConnected = false;
    this.subscriptions.clear();
  }

  getConnectionStatus() {
    return this.isConnected;
  }
}

export default new CoinbaseWebSocket();
